// extracted by mini-css-extract-plugin
export default {"ns_verified_label":"UserProfilePage_ns_verified_label__hEqK8","ns_verify_button":"UserProfilePage_ns_verify_button__8Z-sk"};